const cardItems = [
  {
    title: '《流浪地球3》导演剪辑版',
    desc: '郭帆导演终极版本，新增40分钟未公开画面，太阳氦闪危机全面升级，人类命运面临终极抉择。',
    image: 'https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20poster%20style%20with%20giant%20planet%20and%20spaceship%20in%20deep%20space%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20deep%20black%20contrast%2C%20cinematic%20epic%20scale%2C%20no%20text%2C%20dark%20atmospheric%20mood%2C%20movie%20poster%20aesthetic&width=800&height=1120&seq=card-01&orientation=portrait',
    tag: '科幻巨制',
    rating: '9.2',
  },
  {
    title: '《我的阿勒泰》完整版',
    desc: '马伊琍、于适主演，李娟散文改编，新疆阿勒泰的旷野之美与人间温情交织的治愈佳作。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20film%20poster%20featuring%20vast%20grassland%20and%20distant%20mountains%20at%20sunset%2C%20warm%20golden%20light%20bathing%20the%20landscape%2C%20nostalgic%20and%20peaceful%20atmosphere%2C%20no%20text%2C%20cinematic%20composition%2C%20natural%20beauty&width=800&height=1120&seq=card-02&orientation=portrait',
    tag: '治愈佳作',
    rating: '8.9',
  },
  {
    title: '《鱿鱼游戏》第三季',
    desc: '全球现象级韩剧最终季，李政宰回归，全新致命游戏规则揭晓，终极赢家即将诞生。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20drama%20poster%20style%20with%20geometric%20shapes%20and%20dramatic%20red%20and%20black%20color%20scheme%2C%20suspenseful%20dark%20atmosphere%2C%20minimal%20but%20striking%20visual%2C%20no%20text%2C%20intense%20mood%2C%20cinematic%20poster&width=800&height=1120&seq=card-03&orientation=portrait',
    tag: '全球现象',
    rating: '9.5',
  },
  {
    title: '《唐朝诡事录》第二季',
    desc: '古装悬疑探案剧续作，杨志刚杨旭文再度联手，大唐奇案诡事悬念迭起，服化道精美绝伦。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20mystery%20drama%20poster%2C%20traditional%20Chinese%20architecture%20in%20mist%2C%20lanterns%20and%20shadows%2C%20warm%20amber%20and%20deep%20black%20tones%2C%20no%20text%2C%20atmospheric%20and%20mysterious%2C%20historical%20elegance&width=800&height=1120&seq=card-04&orientation=portrait',
    tag: '古装悬疑',
    rating: '8.7',
  },
  {
    title: '《小丑2：双重妄想》',
    desc: '华金·菲尼克斯与Lady Gaga联袂，音乐与疯狂交织的DC黑暗之作，威尼斯电影节话题之作。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20psychological%20drama%20movie%20poster%20with%20dramatic%20stage%20lighting%20and%20shadow%20play%2C%20deep%20crimson%20and%20black%20color%20palette%2C%20theatrical%20and%20intense%20mood%2C%20no%20text%2C%20cinematic%20composition%2C%20haunting%20atmosphere&width=800&height=1120&seq=card-05&orientation=portrait',
    tag: 'DC黑暗',
    rating: '8.4',
  },
  {
    title: '《狂飙》4K杜比版',
    desc: '年度爆款国产剧4K杜比视界重制版，张颂文张译飙戏名场面高清重映，细节分毫毕现。',
    image: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20Chinese%20drama%20poster%20with%20urban%20nightscape%20and%20neon%20reflections%2C%20rain%20soaked%20streets%2C%20dramatic%20contrast%20between%20warm%20and%20cool%20tones%2C%20no%20text%2C%20gritty%20cinematic%20style%2C%20intense%20urban%20atmosphere&width=800&height=1120&seq=card-06&orientation=portrait',
    tag: '国产爆款',
    rating: '9.4',
  },
  {
    title: '《蜘蛛侠：纵横宇宙》加长版',
    desc: '奥斯卡最佳动画续作加长版，迈尔斯与格温的多元宇宙冒险新增15分钟精彩战斗场面。',
    image: 'https://readdy.ai/api/search-image?query=Animated%20superhero%20movie%20poster%20with%20dynamic%20comic%20book%20style%2C%20vibrant%20neon%20colors%20against%20dark%20background%2C%20spider%20web%20geometric%20patterns%2C%20no%20text%2C%20energetic%20and%20modern%20composition%2C%20bold%20graphic%20design&width=800&height=1120&seq=card-07&orientation=portrait',
    tag: '动画神作',
    rating: '9.1',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1024px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-accent-500/10 text-accent-400 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-star-fill text-xs"></i>
            编辑精选
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-100 mb-2">
            精选推荐
          </h2>
          <p className="text-foreground-500 text-sm">编辑部精心挑选的优质影视内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {cardItems.slice(0, 4).map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-200/70 border border-background-300/40 hover:border-background-400/60 transition-all cursor-pointer"
            >
              <div className="relative aspect-[2/3] overflow-hidden bg-background-300/30">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-background-900/80 text-foreground-50 text-xs font-semibold whitespace-nowrap">
                    <i className="ri-star-fill text-secondary-400 text-xs"></i>
                    {item.rating}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-1 rounded-md bg-primary-500/90 text-foreground-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-200 mb-1 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-xs line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
          {cardItems.slice(4).map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-200/70 border border-background-300/40 hover:border-background-400/60 transition-all cursor-pointer"
            >
              <div className="relative aspect-[2/1.5] overflow-hidden bg-background-300/30">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-background-900/80 text-foreground-50 text-xs font-semibold whitespace-nowrap">
                    <i className="ri-star-fill text-secondary-400 text-xs"></i>
                    {item.rating}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-1 rounded-md bg-accent-500/90 text-foreground-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-200 mb-1 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-xs line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}